const timelinePanels = [
	{
		"year": 2016,
		"bgImg": "https://media.frame.media/pact-twitter-tl/1_protestDESKTOP.jpg",
		"bgMobile": "https://media.frame.media/pact-twitter-tl/1_protest.jpg",
	},
	{
		"year": 2017,
		"bgImg": "https://media.frame.media/pact-twitter-tl/2_sign.jpg",
	},
	{
		"year": 2018,
		"bgImg": "https://media.frame.media/pact-twitter-tl/3_fist.jpg",
	},
	{
		"year": 2019,
		"bgImg": "https://media.frame.media/pact-twitter-tl/4_whitefam.jpg",
	},
	{
		"year": 2020,
		"bgImg": "https://media.frame.media/pact-twitter-tl/5_candleDESKTOPJPG.jpg",
		"bgMobile": "https://media.frame.media/pact-twitter-tl/5_candle.jpg",
	},
]

export default timelinePanels;